export const CloseBlue = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24}>
    <defs>
      <clipPath id="a">
        <path fill="none" d="M306 443.001h24v24h-24z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" data-name="Icon fechar" transform="translate(-306 -443.001)">
      <path
        fill="#0274d2"
        d="M323.069 449.932a.753.753 0 0 0-1.064 0l-4 4-4-4a.753.753 0 0 0-1.064 1.065l4 4-4 4a.753.753 0 1 0 1.064 1.064l4-4 4 4a.753.753 0 0 0 1.064-1.064l-4-4 4-4a.754.754 0 0 0 0-1.065Z"
        data-name="Icon"
      />
    </g>
  </svg>
);
